import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { Subscription as RxSubscription } from 'rxjs';

import { IExtraInfo } from '../../../../app/interfaces/extra-info';
import { ProductInfoDataSource } from '../../services/product-info-data-source';
import { ProductInfoEdit } from '../edit/component';

@Component({
    selector: 'extra-info-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class ProductInfoList implements OnInit, OnDestroy {
  public loading: boolean;
  public productData: IExtraInfo[];
  public paymentData: IExtraInfo[];
  private Subscriptions: RxSubscription[] = [];

  constructor(
    private dialog: MatDialog,
    protected dialogRef: MatDialogRef<ProductInfoList>,
    private readonly changeDetectorRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private DataSource: ProductInfoDataSource
  ) {}

  ngOnInit() {
    this.Subscriptions.push(
      this.DataSource.loading.subscribe((loading) => (this.loading = loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe((data) => {
        this.productData = data.filter((r) => r.type === 'product');
        this.paymentData = data.filter((r) => r.type === 'payment');
      })
    );
  }

  drop(event: CdkDragDrop<IExtraInfo[]>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
    }
      const {data, id: type} = event.container;
      const OrderedInfos = data.map((row, order) => {
        const {id} = row;
        return {
          order,
          id,
          type,
        };
      });
      this.DataSource.setOrder(OrderedInfos);
  }

  public editItem(ExtraInfo?: IExtraInfo) {
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.data = {
      ProductInfo: ExtraInfo,
      dataSource: this.DataSource,
    };

    this.Subscriptions.push(
      this.dialog
        .open(ProductInfoEdit, config)
        .afterClosed()
        .subscribe((result) => {
          !!result && this.DataSource.save(result);
        })
    );
  }

  public deleteItem(ExtraInfo: IExtraInfo) {
    confirm('Are you sure you want to delete: ' + ExtraInfo.title) &&
      this.DataSource.delete(ExtraInfo);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
